module.exports = __webpack_public_path__ + "img/img_ok.02ff8c82.png";